function TrashCanIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 20 20'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.66699 5.00033C1.66699 4.54009 2.04009 4.16699 2.50033 4.16699H17.5003C17.9606 4.16699 18.3337 4.54009 18.3337 5.00033C18.3337 5.46056 17.9606 5.83366 17.5003 5.83366H2.50033C2.04009 5.83366 1.66699 5.46056 1.66699 5.00033Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.33301 2.49967C8.11199 2.49967 7.90003 2.58747 7.74375 2.74375C7.58747 2.90003 7.49967 3.11199 7.49967 3.33301V4.16634H12.4997V3.33301C12.4997 3.11199 12.4119 2.90003 12.2556 2.74375C12.0993 2.58747 11.8874 2.49967 11.6663 2.49967H8.33301ZM14.1663 4.16634V3.33301C14.1663 2.66997 13.9029 2.03408 13.4341 1.56524C12.9653 1.0964 12.3294 0.833008 11.6663 0.833008H8.33301C7.66997 0.833008 7.03408 1.0964 6.56524 1.56524C6.0964 2.03408 5.83301 2.66997 5.83301 3.33301V4.16634H4.16634C3.7061 4.16634 3.33301 4.53944 3.33301 4.99967V16.6663C3.33301 17.3294 3.5964 17.9653 4.06524 18.4341C4.53408 18.9029 5.16997 19.1663 5.83301 19.1663H14.1663C14.8294 19.1663 15.4653 18.9029 15.9341 18.4341C16.4029 17.9653 16.6663 17.3294 16.6663 16.6663V4.99967C16.6663 4.53944 16.2932 4.16634 15.833 4.16634H14.1663ZM4.99967 5.83301V16.6663C4.99967 16.8874 5.08747 17.0993 5.24375 17.2556C5.40003 17.4119 5.61199 17.4997 5.83301 17.4997H14.1663C14.3874 17.4997 14.5993 17.4119 14.7556 17.2556C14.9119 17.0993 14.9997 16.8874 14.9997 16.6663V5.83301H4.99967Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.33333 8.33301C8.79357 8.33301 9.16667 8.7061 9.16667 9.16634V14.1663C9.16667 14.6266 8.79357 14.9997 8.33333 14.9997C7.8731 14.9997 7.5 14.6266 7.5 14.1663V9.16634C7.5 8.7061 7.8731 8.33301 8.33333 8.33301Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.6668 8.33301C12.1271 8.33301 12.5002 8.7061 12.5002 9.16634V14.1663C12.5002 14.6266 12.1271 14.9997 11.6668 14.9997C11.2066 14.9997 10.8335 14.6266 10.8335 14.1663V9.16634C10.8335 8.7061 11.2066 8.33301 11.6668 8.33301Z'
        />
      </svg>
    </span>
  );
}

export default TrashCanIcon;
